import API from './Api';

class EvaluationTypesAPI extends API {
  constructor() {
    super('/evaluation-types');
  }
}

export default EvaluationTypesAPI;